<!-- TEMPLATE -->
<template>
  <div 
      class="dean-code-copy"
      @mouseover="ctrlCAllowed = true"
      @mouseleave="ctrlCAllowed = false">
      <dean-tooltip class="tooltip" @click.native="copy()">
        <div slot="activator">
          <dean-icon
            class="copy"
            :glyph="iconCopy"
            height="15"
            width="15"
            >
          </dean-icon>
        </div>
        Kopi&euml;ren
      </dean-tooltip>
    <div class="code">
      <span v-if="removeText == false">{{ text }}</span>
      <slot></slot>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import { Component, Prop } from 'vue-property-decorator';

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

import deanIcon from './deanIcon.vue'
import deanTooltip from './deanTooltip.vue'
import iconCopy from '../svg/feather-icons/copy.svg';

@Component({
  components: {
    deanIcon,
    deanTooltip
  }
})
export default class deanCodeCopy extends Vue {
  iconCopy: object = iconCopy;
  // PROPSf
  @Prop({ default: '' }) text!: string;
  @Prop({ default: false }) removeText: boolean

  keyPressCtrlC = {
    ctrl: false,
    c: false
  }

  ctrlCAllowed = false

  get selection() {
    return window.getSelection()
  }

  keyPressListener(event) {
    if (this.ctrlCAllowed == true) {
      if (event.keyCode == 224 || event.keyCode == 67) {
        if (event.keyCode == 224) {
          this.keyPressCtrlC.ctrl = true
        }
        if (event.keyCode == 67) {
          this.keyPressCtrlC.c = true
        }
        console.log(this.keyPressCtrlC)
      } else {
        this.keyPressCtrlC = {
          ctrl: false,
          c: false
        }
      }
      
      if (this.keyPressCtrlC.ctrl == true && this.keyPressCtrlC.c == true) {
        console.log(this.selection)
        this.copy();
        this.keyPressCtrlC = {
          ctrl: false,
          c: false
        }
      }
    }
  }

  copy() {
    this.$copyText(this.text).then(
      response => {
        this.$emit('copy', true)
      }, 
      error => {
        this.$emit('copy', false)
      }
    )
  }

  created() {
    window.addEventListener("keydown", this.keyPressListener);
  }
  
  destroyed() {
    window.removeEventListener("keydown", this.keyPressListener);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap');

.dean-code-copy {
  padding: 10px;
  position: relative;

  .code {
    font-family: 'Courier Prime', monospace;
    background-color: var(--color-dark, $color-dark);
    color: white;
    padding: 30px 10px 10px 10px;
    @include border-radius(10px);
  }

  .tooltip {
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .copy {
    fill: white;
    cursor: pointer;
  }
}

</style>
